import { jsx } from "react/jsx-runtime";
import { Box, Modal, Paragraph, Heading, TriggerText } from "@zillow/constellation-10";
import { event } from "@zillow/universal-analytics";
import PropTypes from "prop-types";
import "react";
const LegalPopover = ({
  text,
  triggerText,
  interactionEventCmsInfo,
  className,
  style
}) => {
  const onOpenInteractionEvent = interactionEventCmsInfo ? {
    envelope: {
      event_type_id: "5030",
      event_type_version_id: "1",
      event_template_id: "297",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_modal",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_open"
    },
    cms_info: interactionEventCmsInfo
  } : null;
  const onCloseInteractionEvent = interactionEventCmsInfo ? {
    envelope: {
      event_type_id: "2051",
      event_type_version_id: "1",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_modal",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_close"
    },
    cms_info: interactionEventCmsInfo
  } : null;
  return /* @__PURE__ */ jsx(Box, { css: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "default",
    marginBottom: "default"
  }, className, style, children: /* @__PURE__ */ jsx(Modal, { size: "md", trigger: /* @__PURE__ */ jsx(TriggerText, { css: {
    fontSize: "body-sm"
  }, children: triggerText }), header: /* @__PURE__ */ jsx(Heading, { level: 2, css: {
    textAlign: "center"
  }, children: "Calculator Disclaimer" }), body: /* @__PURE__ */ jsx(Paragraph, { children: text }), onOpenChange: (open) => {
    if (open && onOpenInteractionEvent) {
      event(onOpenInteractionEvent);
    } else if (!open && onCloseInteractionEvent) {
      event(onCloseInteractionEvent);
    }
  } }) });
};
LegalPopover.propTypes = {
  text: PropTypes.string,
  triggerText: PropTypes.string,
  interactionEventCmsInfo: PropTypes.object,
  style: PropTypes.object,
  className: PropTypes.string
};
export {
  LegalPopover as default
};
